import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-json-viewer-dialog',
  templateUrl: './json-viewer-dialog.component.html',
  styles: [`
    mat-dialog-content {
      padding: 0 24px;
      max-height: none;
    }
    ngx-json-viewer {
      display: block;
      white-space: nowrap;
    }
  `]
})
export class JsonViewerDialogComponent {
  title: string;

  constructor(
    public dialogRef: MatDialogRef<JsonViewerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; json: any }
  ) {
    this.title = data.title;
  }

  close() {
    this.dialogRef.close();
  }
}
